module.exports = "\r\n<nav class=\"leftsettingbox\">\r\n    <ul class=\"list-unstyled settinglist\">  \r\n        <li><a [routerLink]=\"['entitySummary']\" hasPermission=\"reports.entityReport.entitySummary.active\"   routerLinkActive=\"selected\"><strong>Entity Summary Report</strong></a></li>  \r\n    </ul>     \r\n</nav> \r\n<router-outlet></router-outlet> \r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/entityReport/entity.component.html
// module id = ./src/app/reports/entityReport/entity.component.html
// module chunks = main